export default "__VITE_ASSET__CWfLVO01__"